import React from "react";
import logo from "../../assets/images/DENT_LOGO.png";
import Title from "../Login/Components/title/title";
import "../Finding_a_Denter/Component/RequestInfo.css";
import RequestInfo from "./Component/RequestInfo";

class Finding_a_Denter extends React.Component {
  // fake authentication Promise
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        // fade out
        ele.classList.add("available");
        setTimeout(() => {
          // remove from DOM
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }

  render() {
    return (
      <React.Fragment>
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
          <div className="text-center mx-auto">
            <span className="iconSup mx-auto">
              <img
                src={logo}
                alt="logo"
                width="15%"
                className="imgSizeLogo mx-auto"
              />
            </span>
          </div>
        </nav>
        <Title
          text1="You’re all set! You will get an email shortly with a price estimate."
        />
        <div className="container">
          <div className="mt-4">
            <RequestInfo />
          </div>
          <div className="text-center">
            <button
              className="btn btn-secondary mb-5"
              onClick={() => (window.location = "/home")}
            >
              Back to home
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Finding_a_Denter;
